import React from "react";
import SwapForm from "components/form/SwapForm";
import TransactionHistory from "components/table";
import { useRootContext } from "context/app-context";
import { Image } from "react-bootstrap";

import "./Swap.scss";

const Swap = () => {
  const { isSignWallet } = useRootContext();
  return (
    <>
      <div className="swap-section">
        <div className="grid">
          <Image src={process.env.REACT_APP_S3_IMAGE_PATH + "sub-page-bg.png"} className="grid" />
          <Image src={process.env.REACT_APP_S3_IMAGE_PATH + "noise.png"} className="grains" />
        </div>

        <div className="hero-content">
          <div className="sub-page-content">
            <h2 className="sub-title mb-0">Swap $TVK to $VANRY</h2>
          </div>
          <SwapForm />
        </div>
      </div>

      <div className="swap-transaction">
        {isSignWallet && <TransactionHistory />}
      </div>
    </>
  );
};

export default Swap;
